import { ReadOnlyCartController } from '../controllers/readOnlyCartController';
import templateUrl from './readOnlyCart.html';

export function ReadOnlyCartDirective() {
    return {
        scope: {
            totals: '=',
            summary: '=',
            externalLoading: '=?'
        },
        replace: true,
        controller: ReadOnlyCartController,
        templateUrl
    };
}
